import { useState, useEffect } from "react";

const useHttpClient = (httpClientInstance) => {
  const [error, setError] = useState(null);

  // request interceptor
  const reqInterceptor = httpClientInstance.interceptors.request.use(
    async (config) => {
      setError(null);
      if (config.data) {
        config.data =
          config.data instanceof FormData
            ? config.data
            : JSON.parse(JSON.stringify(config.data));
      }
      const bearerToken = await localStorage.getItem("token");
      if (bearerToken) {
        config.headers.Authorization = `Bearer ${bearerToken}`;
      }
      return config;
    },
    (err) => {
      setError(err);
      return Promise.reject(err);
    }
  );

  const resInterceptor = httpClientInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    (err) => {
      let formattedMessage = null;

      if (err?.response) {
        switch (err.response.status) {
          case 500:
            formattedMessage = "Unknown error";
            break;
          default:
            break;
        }

        if (err.response.data?.message) {
          formattedMessage = err.response.data.message;
        }

        if (err.response.data?.errors) {
          Object.keys(err.response.data.errors).forEach((errorKey) => {
            err.response.data.errors[errorKey].forEach((line) => {
              formattedMessage += `\r\n${line}`;
            });
          });
        }

        // 401 обробляється interceptor'ом в apiClient.js — не показуємо як помилку тут
        if (err.response.status !== 401) {
          setError(formattedMessage);
        }
      }

      return Promise.reject(err);
    }
  );

  useEffect(() => {
    return () => {
      httpClientInstance.interceptors.request.eject(reqInterceptor);
      httpClientInstance.interceptors.response.eject(resInterceptor);
    };
  }, [reqInterceptor, resInterceptor]);

  const errorClearedHandler = () => {
    setError(null);
  };

  return [error, errorClearedHandler];
};

export default useHttpClient;
